import camelCase from "lodash/camelCase";
import some from "lodash/some";
import startCase from "lodash/startCase";
import values from "lodash/values";
import { getVisibleProperties } from "PFCore/helpers/templates";
import { AccessLevel, CurrentProfile, CustomType, CustomTypes, Template } from "PFTypes";

const PROPERTIES_TO_VALIDATE_PERMISSIONS = ["booking_category_id"];

const isPropertyVisibleInAnyPermissionGroup = (
  currentProfile: CurrentProfile,
  customTypes: CustomTypes,
  propertyName: string
) => {
  const customType = customTypes.find((type) => type.name === propertyName);
  const allCrossGroups = values(currentProfile.permissionsGroup.crossGroupPermissions);

  if (customType) {
    return some(allCrossGroups, (crossGroupPermission) => {
      const accessLevel = crossGroupPermission.activityCustomTypesAccessLevels[customType.id];
      return [AccessLevel.ReadWrite, AccessLevel.ReadOnly].includes(accessLevel);
    });
  } else if (propertyName === "booking_category_id") {
    return some(allCrossGroups, (crossGroupPermission) => {
      const accessLevel = crossGroupPermission.activityFieldsAccessLevels["bookingCategory"];
      return [AccessLevel.ReadWrite, AccessLevel.ReadOnly].includes(accessLevel);
    });
  }
  return false;
};

export const getTemplateVisibleProperties = (
  customTypes: CustomType[],
  currentProfile: CurrentProfile,
  blockedProperties: string[],
  template?: Template,
  sectionKey?: string
) => {
  const visibleProperties = template ? getVisibleProperties(template, sectionKey) : [];

  return visibleProperties
    .filter(({ name }) => !blockedProperties.includes(name))
    .filter((element) => {
      if (element.type === "custom_field" || PROPERTIES_TO_VALIDATE_PERMISSIONS.includes(element.name)) {
        return isPropertyVisibleInAnyPermissionGroup(currentProfile, customTypes, element.name);
      }
      return true;
    })
    .map((element) => {
      const title =
        element.type === "custom_field"
          ? customTypes.find((type) => type.name === element.name)!.display_as
          : element.title;
      return { ...element, title };
    });
};

export const getTableColumnsFromProperties = (
  templateVisibleProperties: {
    name: string;
    title?: string;
    type: string;
    kind?: string;
  }[]
) =>
  templateVisibleProperties.map(({ name, title, type, kind }) => ({
    name,
    title: title || startCase(camelCase(name)),
    type: type,
    orderKey: type === "custom_field" && kind === "single" ? `custom_fields.${name}` : null
  }));
